import PropTypes from "prop-types";
import * as Yup from "yup";

import { useCallback, useMemo, useEffect, useState } from "react";
import { useForm, FormProvider } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { styled } from "@mui/material/styles";
// @mui
import LoadingButton from "@mui/lab/LoadingButton";
import { FormControl, InputLabel, Input, Dialog } from "@mui/material";
// import { IoIosCloseCircleOutline } from 'react-icons/io';
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import Stack from "@mui/material/Stack";
import Grid from "@mui/material/Unstable_Grid2";
import Typography from "@mui/material/Typography";

import { useRouter } from "src/routes/hooks";
import Swal from "sweetalert2";

import Iconify from "src/components/iconify";
import {
  RHFTextField,
  RHFUpload,
  RHFAutocomplete,
} from "src/components/hook-form";
import { format } from "date-fns";

import httpCommon from "src/http-common";
import axios from "axios";
import RHFTextArea from "src/components/hook-form/rfh-textarea";
import QrCode from "src/components/qrcode";

import { BsQrCode } from "react-icons/bs";
import { PATH_AFTER_LOGIN } from "src/config-global";
import { CiCalendar } from "react-icons/ci";
import { IconButton } from "yet-another-react-lightbox";
import {
  DatePicker,
  DateTimePicker,
  LocalizationProvider,
} from "@mui/x-date-pickers";
import { toast } from "sonner";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";

import LoderImg from "./Spin-loder.gif";

import LoderImg2 from "./Spain_loderImg.gif";
import Spin from "./Spinner.gif";
// ----------------------------------------------------------------------

export default function UserNewEditForm({ currentUser }) {
  const router = useRouter();
  const url = httpCommon.defaults.baseURL;
  // const getId = localStorage.getItem('QRId');
  const getId = localStorage.getItem("ww_QRId");

  // const EmpId = localStorage.getItem('emp_mst_empl_id');
  const loginId = localStorage.getItem("ww_emp_mst_empl_id");
  const getHsp = localStorage.getItem("ww_Hsp");
  const [proceed, setProceed] = useState(true);
  const [imageFile, setImageFile] = useState([]);
  const [Priority, setPriority] = useState([]);
  const [DrpWorkArea, setDrpWorkArea] = useState([]);
  const [DrpData, setDrpData] = useState([]);
  const [UserInfoData, setUserInfoData] = useState([]);
  const [DrpWorkGroup, setDrpWorkGroup] = useState([]);
  const [wrkGrp, setWrkGrp] = useState("");

  const [DrpAssetLocation, setDrpAssetLocation] = useState([]);
  const [DrpAsset, setDrpAsset] = useState([]);
  const [DrpFaultCode, setDrpFaultCode] = useState([]);
  const [AssetNumber, setAssetNumber] = useState([]);
  const [phnNo, setPhnNo] = useState("");
  const [email, setEmail] = useState("");
  const Username = UserInfoData?.emp_mst_name || "";
  // const userdept = UserInfoData?.emp_det_costcenter || '';
  const [userdept, setUserDept] = useState("");
  const [selectedWorkArea, setSelectedWorkArea] = useState("");
  const [NameDT, setNameDT] = useState(Username);
  const [DeptDT, setDeptDT] = useState(userdept);
  const [PhnDT, setPhnDT] = useState(phnNo);
  const [DrpDataLeval, setDrpDataLeval] = useState([]);
  const [DrpDataLevelQr, setDrpDataLevelQr] = useState([]);
  const [disable, setDisable] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  // level trigger
  const [levelD, setLevel] = useState();
  const [assetLD, setAssetLD] = useState();
  const [assetNoD, setAssetNoD] = useState("");
  const [workD, setWorkD] = useState("");

  const [faultyCode, setFaultyCode] = useState();
  const [priorityM, setPriorityM] = useState("");
  const [openQr, setOpenQr] = useState(false);
  const [Qr, setQr] = useState();
  const [employeId, setEmployeId] = useState("");
  const [loadingLabel, setLabelLoading] = useState({
    workArea: false,
    level: false,
    assetLocation: false,
    assetNumber: false,
    faultCode: false,
    priority: false,
    workGroup: false,
  });

  const DateChangeToggle = "1";

  const rawDate = new Date();

  const formattedDate = format(rawDate, "dd-MM-yyyy HH:mm", {
    useAdditionalDayOfYearTokens: true,
  });

  // Prevent browser default behavior for back button
  useEffect(() => {
    const handleBackButton = (event) => {
      event.preventDefault();
      // router.push(PATH_AFTER_LOGIN);
    };

    window.addEventListener("popstate", handleBackButton);

    return () => {
      window.removeEventListener("popstate", handleBackButton);
    };
  }, [router]);

  useEffect(() => {
    document.body.classList.remove("customNav");
    const handleThemeOnLoad = () => {
      const storedValue = localStorage.getItem("dataDark");

      if (storedValue === "dark") {
        document.body.classList.add("custom-darkClass");
      } else {
        document.body.classList.remove("custom-darkClass");
      }
    };
    handleThemeOnLoad();
    return () => {
      document.body.classList.remove("custom-darkClass");
    };
  }, []);

  // fething user data
  useEffect(() => {
    setLoading(true);
    const fetchuserInfo = async () => {
      const requestData = {
        site_cd: getHsp,
        login_id: loginId,
        mst_rowID: 0,
      };

      try {
        const response = await httpCommon.post("/GetUserInfo.php", requestData);

        if (response.data.status === "SUCCESS") {
          const res = response.data.data.query1_response[0];

          console.log("response", res);

          if (res) {
            setUserInfoData(res);
            setPhnNo(res.emp_mst_homephone ? res.emp_mst_homephone : "");
            setEmployeId(res.emp_mst_empl_id);
            setUserDept(res.emp_det_department);
            localStorage.setItem("dept", res.emp_det_department);
            setEmail(res.emp_det_email_id);
          }
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    // Call the fetchuserInfo function when the component mounts.
    fetchuserInfo();
  }, [getHsp, getId]);

  useEffect(() => {
    setLabelLoading((pre) => ({
      ...pre,
      workArea: true,
    }));
    // workarea droupDown
    const getDrpWorkArea = async () => {
      setLabelLoading((pre) => ({
        ...pre,
        workArea: true,
      }));
      const site = getHsp;
      try {
        const response = await httpCommon.get(
          `/WorkAreaDropDown.php?site_cd=${site}`,
        );

        if (response.data.status === "SUCCESS") {
          setDrpWorkArea(response.data.data);
          setLabelLoading((pre) => ({
            ...pre,
            workArea: false,
          }));
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    getDrpWorkArea();
  }, [getHsp]);

  // get Priority

  useEffect(() => {
    const getPriority = async () => {
      try {
        const res = await httpCommon.get(
          `/OriginalPriorityDropdown.php/?site_cd=${getHsp}`,
        );
        console.log("original_Priority", res);
        if (res.data.status === "SUCCESS") {
          setPriorityM(res?.data?.data[0]?.dft_mst_wkr_pri);
        }
      } catch (error) {
        console.log(error);
      }
    };
    getPriority();
  }, [getHsp]);

  // level droupDown
  const LevalDropdown = async (value) => {
    setLabelLoading((pre) => ({
      ...pre,
      priority: true,
    }));
    const cid = localStorage.getItem("ww_Hsp");
    const workId = getValues("wkr_mst_work_area");

    try {
      const response = await httpCommon.get(
        `/levelDropdown.php/?site_cd=${cid}&wrk_Ara=${workId}`,
      );
      console.log("levelllllllll", response);
      if (response.data.status === "SUCCESS") {
        setLabelLoading((pre) => ({
          ...pre,
          priority: false,
        }));
        if (value) {
          setDrpDataLevelQr(response.data.data);
        } else {
          setDrpDataLeval(response.data.data);
        }
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  // workGroup droupDown
  useEffect(() => {
    const workGroupdown = async () => {
      setLabelLoading((pre) => ({
        ...pre,
        workGroup: true,
      }));
      const cid = localStorage.getItem("ww_Hsp");

      try {
        const response = await httpCommon.get(
          `/WorkGroupDropDown.php?site_cd=${cid}`,
        );

        if (response.data.status === "SUCCESS") {
          setLabelLoading((pre) => ({
            ...pre,
            workGroup: false,
          }));
          setDrpWorkGroup(response.data.data);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    workGroupdown();
  }, []);

  // Asset DroupDown
  const getAssetNumber = async (value) => {
    const id = localStorage.getItem("ww_Hsp");
    const level = getValues("wkr_mst_location");
    const work = getValues("wkr_mst_work_area");
    const location = getValues("wkr_mst_assetlocn");
    setLabelLoading((pre) => ({
      ...pre,
      assetNumber: true,
    }));
    try {
      const response = await httpCommon.get(
        `/assetNoDropDown.php/?site_cd=${id}&ast_lvl=${level}&wrk_Ara=${work}&asset_locn=${location}`,
      );
      console.log("response Asset num", response);
      if (response.data.status === "SUCCESS") {
        setLabelLoading((pre) => ({
          ...pre,
          assetNumber: false,
        }));
        setAssetNumber(response.data.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  // get Location DroupDown
  const getLocationAsset = async (value) => {
    console.log(value, "Asset Location");
    const level = getValues("wkr_mst_location");
    const work = getValues("wkr_mst_work_area");
    const id = localStorage.getItem("ww_Hsp");
    setLabelLoading((pre) => ({
      ...pre,
      assetLocation: true,
    }));
    try {
      const response = await httpCommon.get(
        `/AssetLocationDropdown.php/?site_cd=${id}&ast_lvl=${level}&wrk_Ara=${work}`,
      );

      if (response.data.status === "SUCCESS") {
        setLabelLoading((pre) => ({
          ...pre,
          assetLocation: false,
        }));
        setDrpAssetLocation(response.data.data);
        // getAssetNumber();
      }
    } catch (error) {
      console.log(error);
    }
  };

  // FaultCode DroupDown
  useEffect(() => {
    setLabelLoading((pre) => ({
      ...pre,
      faultCode: true,
    }));

    const getFaultCode = async () => {
      try {
        const res = await httpCommon.get(
          `FaultCodeDropdown.php/?site_cd=${getHsp}`,
        );

        if (res.data.status === "SUCCESS") {
          setLabelLoading((pre) => ({
            ...pre,
            faultCode: false,
          }));
          setDrpFaultCode(res.data.data);
        } else {
          console.log(res.data.data.status);
        }
      } catch (error) {
        console.log(error);
      }
    };
    getFaultCode();
  }, [getHsp]);

  // for form 2
  const NewUserSchema2 = Yup.object().shape({
    wkr_mst_work_area: Yup.string().required("Work Area is required"),
    wkr_mst_location: Yup.string().required("Level is required"),
    wkr_mst_assetno: Yup.string().required("Asset Number is required"),
    wkr_mst_assetlocn: Yup.string().required("Asset Location is Required"),
    wkr_mst_work_group: Yup.string().required("Work group is rquired"),
    wkr_mst_orig_priority: Yup.string(),
    wkr_mst_fault_code: Yup.string().required("Fault Code is required"),
    wkr_mst_wr_descs: Yup.string().required("Request Description is required"),
    status: Yup.string(),
    isVerified: Yup.boolean(),
  });

  const NewUserSchema = Yup.object().shape({
    gs_empl_id: Yup.string(),
    em_name: Yup.string().required("Name is required"),
    department: Yup.string().required("Department is required"),
    emp_mst_homephone: Yup.string().required("Contact number is required"),
    wkr_mst_email: Yup.string().required("Email is required"),
    status: Yup.string(),
    isVerified: Yup.boolean(),
  });

  console.log("email", email);

  const selectedSchema =
    NameDT !== "" || DeptDT !== "" || PhnDT !== ""
      ? NewUserSchema2
      : NewUserSchema;

  const methods = useForm({
    resolver: yupResolver(selectedSchema),
  });

  // setting name here
  useEffect(() => {
    setNameDT(Username);
    setDeptDT(userdept);
    setPhnDT(phnNo);
  }, [Username, userdept, phnNo]);

  const {
    watch,
    setValue,
    trigger,
    getValues,
    handleSubmit,

    formState: { isSubmitting },
  } = methods;

  console.log("hii", getValues());

  // Define the field names you want to check
  const [errorMessage, setErrorMessage] = useState("");
  const values = watch();

  const handleNameChange = (event) => {
    //  setNameDT(event.target.value);
    const newValue = event.target.value;

    if (newValue === "") {
      // Input field is empty
      setNameDT(""); // Clear the state or set it to an empty string
    } else {
      // Input field is not empty
      setNameDT(newValue); // Update the state with the new value
    }
  };

  const handleDeptChange = (event) => {
    setDeptDT(event.target.value);
  };
  const handlePhnChange = (event) => {
    setPhnDT(event.target.value);
  };
  const handleEmailChange = (event) => {
    setPhnDT(event.target.value);
  };

  const handleDrop = useCallback(
    async (acceptedFiles) => {
      setImageFile((pre) => {
        if (!Array.isArray(pre)) {
          // If pre is not an array or undefined, initialize it as an empty array
          pre = [];
        }
        return [...pre, ...acceptedFiles]; // Spread the contents of pre and acceptedFiles
      });

      const images = watch("images") || [];
      setValue("file", acceptedFiles);
      // Check if the total number of selected files exceeds 3
      if (images.length + acceptedFiles.length > 3) {
        setErrorMessage("You can only select up to 3 photos.");

        // Clear the error message after 3 seconds
        setTimeout(() => {
          setErrorMessage("");
        }, 6000);

        return; // Prevent adding more than 3 photos
      }
      setErrorMessage("");

      const newFiles = acceptedFiles.map((file) => ({
        ...file,
        preview: URL.createObjectURL(file),
      }));
      console.log(newFiles, "accptedFiles");
      setValue("images", [...images, ...newFiles], { shouldValidate: true });
    },
    [setValue, watch],
  );

  // handle function

  // handleWorkChange

  const handleWorkChange = (event, newValue) => {
    setSelectedWorkArea(newValue);
    setDrpAssetLocation([]);
    setAssetNumber([]);
    setAssetLD("");
    setAssetNoD("");
    setValue("wkr_mst_location", "");
    setValue("wkr_mst_assetlocn", "");
    setValue("wkr_mst_assetno", "");

    setLevel("");

    const selectedOption = DrpWorkArea.find(
      (item) => item.mst_war_desc === newValue,
    );

    if (selectedOption) {
      // Use setValue from RHF to update the field value
      setValue("wkr_mst_work_area", selectedOption.mst_war_work_area);
      trigger("wkr_mst_work_area"); // Manually trigger validation
      setWorkD(
        `${selectedOption.mst_war_work_area} : ${selectedOption.mst_war_desc}`,
      );
      LevalDropdown();
    }
  };

  const handleRemoveFile = useCallback(
    (inputFile) => {
      // Filter out the inputFile from imageFile
      const filteredFiles = imageFile.filter(
        (file) => file.path !== inputFile.path,
      );
      setImageFile(filteredFiles); // Update imageFile state

      // Filter out the inputFile from values.images
      const filteredImages = values.images.filter(
        (file) => file.preview !== inputFile.preview,
      );
      setValue("images", filteredImages); // Update values.images state
    },
    [setValue, values.images, setImageFile, imageFile],
  );

  const handleRemoveAllFiles = useCallback(() => {
    setValue("images", []); // Remove all files from values.images
    setImageFile([]); // Remove all files from imageFile
  }, [setValue, setImageFile]);

  const handleWorkGroupChange = (e, newValue) => {
    const selectedOption = DrpWorkGroup.find(
      (item) => item.wrk_grp_desc === newValue,
    );
    console.log("newValue", newValue);
    console.log("selectedValues", selectedOption);
    if (selectedOption) {
      setValue("wkr_mst_work_group", selectedOption.wrk_grp_grp_cd);
      trigger("wkr_mst_work_group");
      const updatevalue = selectedOption.wrk_grp_desc;
      console.log("update", updatevalue);
      setWrkGrp(updatevalue);
    }
  };

  const handleLevelChange = (e, newValue) => {
    const selectedValues = DrpDataLeval.find(
      (item) => item.ast_lvl_desc === newValue,
    );
    setValue("wkr_mst_assetlocn", "");
    setValue("wkr_mst_assetno", "");

    setAssetNumber([]);

    if (selectedValues) {
      setLevel(
        `${selectedValues.ast_lvl_ast_lvl} : ${selectedValues.ast_lvl_desc}`,
      );
      setValue("wkr_mst_location", selectedValues.ast_lvl_ast_lvl);
      trigger("wkr_mst_location");
    }
    if (getValues("wkr_mst_location") && getValues("wkr_mst_work_area")) {
      getLocationAsset();
    }
  };

  // level change 2
  const handleLevelChange2 = (e, newValue) => {
    const selectedValues = DrpDataLevelQr.find(
      (item) => item.ast_lvl_desc === newValue,
    );
    setValue("wkr_mst_assetlocn", "");
    setValue("wkr_mst_assetno", "");

    setAssetNumber([]);

    if (selectedValues) {
      setLevel(
        `${selectedValues.ast_lvl_ast_lvl} : ${selectedValues.ast_lvl_desc}`,
      );
      setValue("wkr_mst_location", selectedValues.ast_lvl_ast_lvl);
      trigger("wkr_mst_location");
    }
    if (getValues("wkr_mst_location") && getValues("wkr_mst_work_area")) {
      getLocationAsset();
    }
  };
  // Handle Priority Change
  const handlePriorityChange = (e, newValue) => {
    const selectedValues = Priority.find(
      (item) => item.wrk_pri_desc === newValue,
    );
    if (selectedValues) {
      setValue("wkr_mst_orig_priority", selectedValues.wrk_pri_pri_cd);
      trigger("wkr_mst_orig_priority");
      setPriorityM(
        `${selectedValues.wrk_pri_pri_cd} : ${selectedValues.wrk_pri_desc}`,
      );
    }
  };

  // handleAssetLocation change
  const handleAssetLocation = (e, newValue) => {
    const selectedValues = DrpAssetLocation.find(
      (item) => item.ast_loc_desc === newValue,
    );
    setValue("wkr_mst_assetno", "");

    setAssetNoD("");

    if (selectedValues) {
      setValue("wkr_mst_assetlocn", selectedValues.ast_loc_ast_loc);
      setAssetLD(
        `${selectedValues.ast_loc_ast_loc} : ${selectedValues.ast_loc_desc}`,
      );
      trigger("wkr_mst_assetlocn");

      getAssetNumber();
    }
  };

  const handleFaultChange = (e, newValue) => {
    const selectedValues = DrpFaultCode.find(
      (item) => item.wrk_flt_desc === newValue,
    );
    console.log("selectedValues", selectedValues);
    if (selectedValues) {
      setValue("wkr_mst_fault_code", selectedValues.wrk_flt_fault_cd);

      trigger("wkr_mst_fault_code");
      setFaultyCode(
        `${selectedValues.wrk_flt_fault_cd} : ${selectedValues.wrk_flt_desc}`,
      );
    }
  };

  const handleAssetChange = (event, newValue) => {
    const selectedOptions = AssetNumber.find(
      (item) => item.ast_mst_asset_no === newValue,
    );

    if (selectedOptions) {
      setValue("wkr_mst_assetno", selectedOptions.ast_mst_asset_no);
      setAssetNoD(
        `${selectedOptions.ast_mst_asset_no} : ${selectedOptions.ast_mst_asset_shortdesc}`,
      );

      trigger("wkr_mst_assetno"); // Manually trigger validation
    }
  };

  const handleClose = () => {
    if (Qr) {
      setQr(Qr); // Set the QR code before calling the API
      setOpenQr(false); // Close the QR scanner dialog
    }
  };

  // handling Qr scan
  const handleScan = async (data) => {
    if (data) {
      setQr(data.text);

      try {
        const response = await httpCommon.get(
          `/assetNoScanDropDown.php/?site_cd=${getHsp}&asset_no=${data.text}`,
        );

        if (response.data.status === "SUCCESS") {
          setValue(
            "wkr_mst_work_area",
            response.data.data[0].ast_mst_work_area,
          );
          trigger("wkr_mst_work_area");
          setWorkD(
            `${response.data.data[0].ast_mst_work_area} - ${response.data.data[0].mst_war_desc}`,
          );
          LevalDropdown(response.data.data[0].ast_mst_work_area);
          setValue("wkr_mst_location", response.data.data[0].ast_mst_ast_lvl);
          setLevel(
            `${response.data.data[0].ast_mst_ast_lvl} - ${response.data.data[0].ast_lvl_desc}`,
          );
          // // Asset Location fun
          getLocationAsset(response.data.data[0].ast_mst_ast_lvl);
          setValue("wkr_mst_assetlocn", response.data.data[0].ast_loc_ast_loc);

          setAssetLD(
            `${response.data.data[0].ast_loc_ast_loc} - ${response.data.data[0].ast_loc_desc}`,
          );
          getAssetNumber(response.data.data[0].ast_loc_ast_loc);

          setValue("wkr_mst_assetno", data.text);
          setAssetNoD(
            `${data.text} - ${response.data.data[0].ast_mst_asset_shortdesc}`,
          );
        } else {
          toast.error(
            response.data.message || "Failed to retrieve asset details",
          );
        }
      } catch (error) {
        console.error("Error in QR API:", error);
        toast.error("Invalid Asset No");
      }

      setOpenQr(false); // Close the QR scanner dialog after processing
    }
  };

  // date Picker
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [showDatePicker, setShowDatePicker] = useState(false);

  const handleDateChange = (date) => {
    console.log("Data", date);
    setSelectedDate(date);
    // You can perform any other actions here, such as updating state or sending data to backend
  };
  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      // Handle key press event (Enter key)
    }
  };

  // const handleEmail=(email)=>{
  //   const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  // if(email){
  //   if (emailRegex.test(email)) {

  //     setProceed(true);
  //     return email;
  //   } else {
  //     // Email is invalid

  //     Swal.fire({
  //       icon: 'error',
  //       title: 'Error.',
  //       text: `Invalid email address.`,
  //     });

  //     setProceed(false);
  //   }
  // }else{
  //   setProceed(true)
  //   return ""
  // }
  // }
  console.log("proceed", proceed);
  const handleEmail = (e) => {
    const email = e.target.value;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (email) {
      if (emailRegex.test(email)) {
        setProceed(true);
      } else {
        setProceed(false);
      }
    } else {
      setProceed(true);
    }
    setEmail(email);
  };

  // handle submit
  const onSubmitData = async (data) => {
    const formData = new FormData();
    if (!proceed) {
      Swal.fire({
        icon: "error",
        title: "Error.",
        text: `Invalid email address.`,
      });
    } else {
      // formData.append('department', DeptDT);
      // formData.append('emp_mst_homephone', PhnDT);
      // formData.append('wkr_mst_email', email);
      setValue("em_name", NameDT);
      setValue("department", DeptDT);
      setValue("emp_mst_homephone", PhnDT);
      setValue("wkr_mst_email", email);

      const newData = getValues();
      const requestData = {
        ...newData,
        gs_empl_id: employeId,
        site_cd: getHsp,
        gs_user: getId,
        wkr_det_department: userdept,
        wkr_mst_orig_priority: priorityM,
        workD,
        assetNoD,
        assetLD,
        levelD,
        wrkGrp,
        NameDT,
      };

      Object.entries(requestData).forEach(([key, value]) => {
        formData.append(key, value);
      });

      // Append accepted files from handleDrop function to FormData
      // imageFile.forEach((file) => {
      //   formData.append('files', file);
      // });
      imageFile.forEach((file, index) => {
        formData.append(`files[${index}]`, file);
      });
      // Check if the first file is appended
      const firstFile = imageFile.length > 0 ? imageFile[0] : null;
      console.log("First file appended:", firstFile);
      if (proceed) {
        setDisable(true);
        try {
          // const response = await httpCommon.post('/insertWorkReq.php', requestData, {
          //   headers: {
          //     'Content-Type': 'multipart/form-data',
          //   },
          // });
          setIsLoading(true);
          const response = await axios.post(
            `${url}/insertWorkReq.php`,
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            },
          );
          console.log("response_Form____", response);
          if (response.data.status === "SUCCESS") {
            setIsLoading(false);
            Swal.fire({
              title: `Work Request No ${response.data.ROW_ID}`,
              text: "Your work request created successfully",
              icon: "success",
              confirmButtonText: "OK",
              timer: 2000,
              allowOutsideClick: false,
            }).then((result) => {
              if (result.isConfirmed) {
                router.push("/dashboard/user/list");
              }
            });
            setTimeout(() => {
              router.push("/dashboard/user/list");
            }, 2000);
          } else {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: `${response.data.message}`,
            });
          }
        } catch (error) {
          console.error("error___part", error);
        }
      }
    }
  };

  return (
    <>
      {" "}
      <Dialog
        open={loading}
        // onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <img src={LoderImg2} alt="loderImg" style={{ width: "80px" }} />
        </div>
      </Dialog>
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onSubmitData)}>
          <Grid container spacing={4}>
            <Grid xs={12} md={5} className="RejectStatusCs">
              <Card sx={{ px: 3, pb: 5 }}>
                <Typography variant="subtitle2" sx={{ mb: 3, mt: 2 }}>
                  Requester Information
                </Typography>

                <Box display="flex" flexDirection="column" rowGap={3}>
                  {/* <TextField id="filled-basic" label="Employee ID" disabled variant="filled"  defaultValue={getId} /> */}
                  {/* <div className="usrFrmFld">
                  <FormControl>
                    <InputLabel>Employee ID</InputLabel>
                    <Input type="text" name="gs_empl_id" disabled  value={employeId} />
                  </FormControl>
                </div> */}

                  {(() => {
                    if (employeId) {
                      return (
                        <div className="usrFrmFld">
                          <FormControl>
                            <InputLabel>Employee ID</InputLabel>
                            <Input
                              type="text"
                              value={employeId || " "}
                              onChange={(e) => handleNameChange(e)}
                              // defaultValue={Username}
                              disabled
                            />
                          </FormControl>
                        </div>
                      );
                    }
                    return (
                      <div className="fuWdt">
                        <RHFTextField
                          id="outlined-basic"
                          name="em_name"
                          label="Name"
                          variant="filled"
                          disable
                          value=" "
                          onChange={handleNameChange}
                        />

                        {errorMsg && <p className="errormessage">{errorMsg}</p>}
                      </div>
                    );
                  })()}

                  {(() => {
                    if (UserInfoData.emp_mst_name) {
                      return (
                        <div className="usrFrmFld">
                          <FormControl>
                            <InputLabel>Name</InputLabel>
                            <Input
                              type="text"
                              value={UserInfoData.emp_mst_name}
                              onChange={(e) => handleNameChange(e)}
                              // defaultValue={Username}
                              disabled
                            />
                          </FormControl>
                        </div>
                      );
                    }
                    return (
                      <div className="fuWdt">
                        <RHFTextField
                          id="outlined-basic"
                          name="em_name"
                          label="Name"
                          variant="filled"
                          disable
                          value=" "
                          onChange={handleNameChange}
                        />

                        {errorMsg && <p className="errormessage">{errorMsg}</p>}
                      </div>
                    );
                  })()}
                  <div>
                    {(() => {
                      if (userdept) {
                        return (
                          <div className="usrFrmFld">
                            <FormControl>
                              <InputLabel>Department</InputLabel>
                              <Input
                                type="text"
                                name="department"
                                disabled
                                onChange={handleDeptChange}
                                defaultValue={userdept || ""}
                              />
                            </FormControl>
                          </div>
                        );
                      }
                      return (
                        <div className="fuWdt">
                          <RHFTextField
                            id="outlined-basic"
                            name="department"
                            label="Department"
                            variant="filled"
                            disabled
                            value=" "
                            onChange={handleDeptChange}
                          />
                        </div>
                      );
                    })()}
                  </div>
                  <div>
                    {(() => {
                      if (phnNo) {
                        return (
                          <div className="usrFrmFld">
                            <FormControl>
                              <InputLabel>Contact No</InputLabel>
                              <Input
                                type="text"
                                name="emp_mst_homephone"
                                onChange={handlePhnChange}
                                defaultValue={phnNo || ""}
                                disabled
                              />
                            </FormControl>
                          </div>
                        );
                      }
                      return (
                        <div className="fuWdt">
                          <RHFTextField
                            id="outlined-basic"
                            name="emp_mst_homephone"
                            label="Contact No"
                            variant="filled"
                            disabled
                            value=" "
                            onChange={handlePhnChange}
                          />
                        </div>
                      );
                    })()}
                  </div>
                  {/* field for Email */}
                  <div>
                    <div className=" mb-3">
                      <div className="w-full border border-gray-200 rounded-lg  px-3 py-1 ">
                        <InputLabel>Email</InputLabel>
                        <input
                          className="outline-none w-full"
                          value={email || ""}
                          // onChange={(e) => setEmail(e.target.value)}
                          onChange={handleEmail}
                        />
                      </div>
                    </div>
                  </div>
                </Box>
              </Card>
            </Grid>

            <Grid xs={12} md={7}>
              <Card sx={{ px: 3, pb: 5 }}>
                <Typography variant="subtitle2" sx={{ mb: 3, mt: 2 }}>
                  Work Request Information
                </Typography>

                <Box display="flex" flexDirection="column" rowGap={3}>
                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <div className="datepickfrm">
                      <FormControl>
                        <InputLabel shrink>Request Date</InputLabel>
                        <DateTimePicker
                          value={selectedDate}
                          format="dd/MM/yyyy HH:mm"
                          onChange={(newDate) => {
                            setSelectedDate(newDate);
                            // setShowDatePicker(false);
                          }}
                          slotProps={{
                            textField: {
                              fullWidth: true,
                              className: "customeDate",
                              // style: { marginTop: '7px', width: '100%' },
                            },
                          }}
                        />
                      </FormControl>
                    </div>
                  </LocalizationProvider>

                  <button
                    style={{ background: "transparent", border: "none" }}
                    type="button"
                    className="hideUnhide"
                    onClick={() => setOpenQr(true)}
                    onKeyPress={
                      handleKeyPress
                    } /* Add key press event handler */
                  >
                    <Typography variant="overline">
                      Scan Asset Number
                    </Typography>
                    <BsQrCode size={30} />
                  </button>

                  {/* Qr Scanner end */}

                  {/* QR r Dialog */}
                  <div>
                    <QrCode
                      open={openQr}
                      setOpen={setOpenQr}
                      handleClose={handleClose}
                      setQr={setQr}
                      handleScan={handleScan}
                    />
                  </div>

                  {/* work Area */}
                  <div className="usrFrmFldTwo mt ">
                    <RHFAutocomplete
                      name="wkr_mst_work_area"
                      label="Work Area"
                      value={getValues("wkr_mst_work_area") ? workD : ""}
                      options={DrpWorkArea.map(
                        (DrpDataLeval2) => DrpDataLeval2.mst_war_desc,
                      )}
                      getOptionLabel={(option) => option}
                      onChange={handleWorkChange}
                      isOptionEqualToValue={(option, value) => option === value}
                      renderOption={(props, option) => {
                        const { mst_war_desc, mst_war_work_area } =
                          DrpWorkArea.filter(
                            (DrpDataLeval1) =>
                              DrpDataLeval1.mst_war_desc === option,
                          )[0];

                        if (!mst_war_desc) {
                          return (
                            <li {...props} key={mst_war_desc}>
                              <Iconify
                                key={mst_war_desc}
                                width={28}
                                sx={{ mr: 1 }}
                              />
                              Loading.......
                            </li>
                          );
                        }

                        return (
                          <li {...props} key={mst_war_desc}>
                            <Iconify
                              key={mst_war_desc}
                              width={28}
                              sx={{ mr: 1 }}
                            />
                            {mst_war_work_area} : {mst_war_desc}
                          </li>
                        );
                      }}
                    />
                  </div>
                  {loadingLabel.workArea && DrpWorkArea ? (
                    <div
                    // style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
                    >
                      <img
                        src={Spin}
                        alt="loderImg"
                        style={{ width: "30px" }}
                      />
                    </div>
                  ) : null}
                  {/* work Area End */}

                  {/* level */}
                  {(() => {
                    if (DrpDataLevelQr.length > 0)
                      return (
                        <div className="usrFrmFldTwo">
                          <RHFAutocomplete
                            name="wkr_mst_location"
                            label="Level"
                            defaultValue={getValues("wkr_mst_location")}
                            value={getValues("wkr_mst_location") ? levelD : ""}
                            options={DrpDataLevelQr.map(
                              (item) => item.ast_lvl_desc,
                            )}
                            getOptionLabel={(option) => option}
                            onChange={handleLevelChange2}
                            isOptionEqualToValue={(option, value) =>
                              option === value
                            }
                            renderOption={(props, option) => {
                              // Check if data is available before rendering

                              if (DrpDataLevelQr.length > 0) {
                                const selectedItem = DrpDataLevelQr.find(
                                  (item) => item.ast_lvl_desc === option,
                                );

                                if (!selectedItem) {
                                  return (
                                    <li {...props}>
                                      <Iconify width={28} sx={{ mr: 1 }} />
                                      Loading.......
                                    </li>
                                  );
                                }

                                const { ast_lvl_desc, ast_lvl_ast_lvl } =
                                  selectedItem;

                                if (!ast_lvl_desc) {
                                  return (
                                    <li {...props} key={ast_lvl_desc}>
                                      <Iconify
                                        key={ast_lvl_desc}
                                        width={28}
                                        sx={{ mr: 1 }}
                                      />
                                      Loading.......
                                    </li>
                                  );
                                }

                                return (
                                  <li {...props} key={ast_lvl_desc}>
                                    <Iconify
                                      key={ast_lvl_desc}
                                      width={28}
                                      sx={{ mr: 1 }}
                                    />
                                    {ast_lvl_ast_lvl} : {ast_lvl_desc}
                                  </li>
                                );
                              }
                              return null;
                            }}
                          />
                        </div>
                      );

                    return (
                      <div className="usrFrmFldTwo">
                        <RHFAutocomplete
                          name="wkr_mst_location"
                          label="Level"
                          value={getValues("wkr_mst_location") ? levelD : ""}
                          options={DrpDataLeval.map(
                            (item) => item.ast_lvl_desc,
                          )}
                          getOptionLabel={(option) => option}
                          onChange={handleLevelChange}
                          // onClick={() => LevalDropdown()}
                          isOptionEqualToValue={(option, value) =>
                            option === value
                          }
                          renderOption={(props, option) => {
                            const selectedItem = DrpDataLeval.find(
                              (item) => item.ast_lvl_desc === option,
                            );

                            if (!selectedItem || !selectedWorkArea) {
                              return (
                                <li {...props}>
                                  <Iconify width={28} sx={{ mr: 1 }} />
                                  Loading.......
                                </li>
                              );
                            }

                            const { ast_lvl_desc, ast_lvl_ast_lvl } =
                              selectedItem;

                            return (
                              <li {...props} key={ast_lvl_desc}>
                                <Iconify
                                  key={ast_lvl_desc}
                                  width={28}
                                  sx={{ mr: 1 }}
                                />
                                {ast_lvl_ast_lvl} : {ast_lvl_desc}
                              </li>
                            );
                          }}
                        />
                      </div>
                    );
                  })()}
                  {loadingLabel.level ? (
                    <div
                    // style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
                    >
                      <img
                        src={Spin}
                        alt="loderImg"
                        style={{ width: "30px" }}
                      />
                    </div>
                  ) : null}

                  {/* Work Level end */}

                  {/* Asset Location */}
                  <div className="usrFrmFldTwo">
                    <RHFAutocomplete
                      name="wkr_mst_assetlocn"
                      label="Asset Location"
                      value={getValues("wkr_mst_assetlocn") ? assetLD : ""}
                      options={DrpAssetLocation.map(
                        (DrpDataLeval2) => DrpDataLeval2.ast_loc_desc,
                      )}
                      getOptionLabel={(option) => option}
                      onChange={handleAssetLocation}
                      isOptionEqualToValue={(option, value) => option === value}
                      renderOption={(props, option) => {
                        const { ast_loc_desc, ast_loc_ast_loc } =
                          DrpAssetLocation.filter(
                            (DrpDataLeval1) =>
                              DrpDataLeval1.ast_loc_desc === option,
                          )[0];

                        if (!ast_loc_desc) {
                          return (
                            <li {...props} key={ast_loc_desc}>
                              <Iconify
                                key={ast_loc_desc}
                                width={28}
                                sx={{ mr: 1 }}
                              />
                              Loading.......
                            </li>
                          );
                        }

                        return (
                          <li {...props} key={ast_loc_desc}>
                            <Iconify
                              key={ast_loc_desc}
                              width={28}
                              sx={{ mr: 1 }}
                            />
                            {ast_loc_ast_loc} : {ast_loc_desc}
                          </li>
                        );
                      }}
                    />
                  </div>

                  {loadingLabel.assetLocation ? (
                    <div
                    // style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
                    >
                      <img
                        src={Spin}
                        alt="loderImg"
                        style={{ width: "30px" }}
                      />
                    </div>
                  ) : null}
                  {/* Asset Location End */}

                  {/* Asset Number */}
                  <div className="usrFrmFldTwo">
                    <RHFAutocomplete
                      name="wkr_mst_assetno"
                      label="Asset Number"
                      type="text"
                      value={getValues("wkr_mst_assetno") ? assetNoD : ""}
                      options={AssetNumber.map(
                        (DrpData2) => DrpData2.ast_mst_asset_no,
                      )}
                      getOptionLabel={(option) => option}
                      isOptionEqualToValue={(option, value) => option === value}
                      onChange={handleAssetChange}
                      renderOption={(props, option) => {
                        const { ast_mst_asset_no, ast_mst_asset_shortdesc } =
                          AssetNumber.filter(
                            (DrpData1) => DrpData1.ast_mst_asset_no === option,
                          )[0];

                        if (!ast_mst_asset_no) {
                          return (
                            <li {...props} key={ast_mst_asset_no}>
                              <Iconify
                                key={ast_mst_asset_no}
                                width={28}
                                sx={{ mr: 1 }}
                              />
                              Loading.......
                            </li>
                          );
                        }

                        return (
                          <li {...props} key={ast_mst_asset_no}>
                            <Iconify
                              key={ast_mst_asset_no}
                              width={28}
                              sx={{ mr: 1 }}
                            />
                            {ast_mst_asset_no} : {ast_mst_asset_shortdesc}
                          </li>
                        );
                      }}
                    />
                  </div>
                  {loadingLabel.assetNumber ? (
                    <div
                    // style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
                    >
                      <img
                        src={Spin}
                        alt="loderImg"
                        style={{ width: "30px" }}
                      />
                    </div>
                  ) : null}
                  {/* Asset Number End */}

                  {/* Scan AssetNumber */}

                  {/* work group */}
                  <div className="usrFrmFldTwo">
                    <RHFAutocomplete
                      name="wkr_mst_work_group"
                      label="Work Group"
                      value={getValues("wkr_mst_work_group") ? wrkGrp : ""}
                      options={DrpWorkGroup.map(
                        (DrpData2) => DrpData2.wrk_grp_desc,
                      )}
                      getOptionLabel={(option) => option}
                      onChange={handleWorkGroupChange}
                      isOptionEqualToValue={(option, value) => option === value}
                      renderOption={(props, option) => {
                        const { wrk_grp_desc } = DrpWorkGroup.filter(
                          (DrpData1) => DrpData1.wrk_grp_desc === option,
                        )[0];

                        if (!wrk_grp_desc) {
                          return (
                            <li {...props} key={wrk_grp_desc}>
                              <Iconify
                                key={wrk_grp_desc}
                                width={28}
                                sx={{ mr: 1 }}
                              />
                              Loading.......
                            </li>
                          );
                        }

                        return (
                          <li {...props} key={wrk_grp_desc}>
                            <Iconify
                              key={wrk_grp_desc}
                              width={28}
                              sx={{ mr: 1 }}
                            />
                            {wrk_grp_desc}
                          </li>
                        );
                      }}
                    />
                  </div>
                  {loadingLabel.workGroup ? (
                    <div
                    // style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
                    >
                      <img
                        src={Spin}
                        alt="loderImg"
                        style={{ width: "30px" }}
                      />
                    </div>
                  ) : null}

                  {/* original Priority */}
                  {/* <div className="usrFrmFldTwo">
                  <RHFAutocomplete
                    name="wkr_mst_orig_priority"
                    label="Original Priority"
                    options={Priority.map((DrpData2) => DrpData2.wrk_pri_desc)}
                    value={getValues('wkr_mst_orig_priority') ? priorityM : ''}
                    getOptionLabel={(option) => option}
                    isOptionEqualToValue={(option, value) => option === value}
                    onChange={handlePriorityChange}
                    renderOption={(props, option) => {
                      const { wrk_pri_desc, wrk_pri_pri_cd } = Priority.filter(
                        (DrpData1) => DrpData1.wrk_pri_desc === option
                      )[0];

                      if (!wrk_pri_desc) {
                        return (
                          <li {...props} key={wrk_pri_desc}>
                            <Iconify key={wrk_pri_desc} width={28} sx={{ mr: 1 }} />
                            Loading.......
                          </li>
                        );
                      }

                      return (
                        <li {...props} key={wrk_pri_desc} value={wrk_pri_desc}>
                          <Iconify key={wrk_pri_desc} width={28} sx={{ mr: 1 }} />
                          {wrk_pri_pri_cd} : {wrk_pri_desc}
                        </li>
                      );
                    }}
                  />
                </div>
                {loadingLabel.priority ? (
                  <div
                  >
                    <img src={Spin} alt="loderImg" style={{ width: '30px' }} />
                  </div>
                ) : null} */}
                  {/* original Priority end */}

                  {/* falut code */}
                  <div className="usrFrmFldTwo">
                    <RHFAutocomplete
                      name="wkr_mst_fault_code"
                      label="Fault Code"
                      value={getValues("wkr_mst_fault_code") ? faultyCode : ""}
                      options={DrpFaultCode.map(
                        (DrpData2) => DrpData2.wrk_flt_desc,
                      )}
                      getOptionLabel={(option) => option}
                      isOptionEqualToValue={(option, value) => option === value}
                      onChange={handleFaultChange}
                      renderOption={(props, option) => {
                        const { wrk_flt_desc, wrk_flt_fault_cd } =
                          DrpFaultCode.filter(
                            (DrpData1) => DrpData1.wrk_flt_desc === option,
                          )[0];

                        if (!wrk_flt_desc) {
                          return (
                            <li {...props} key={wrk_flt_desc}>
                              <Iconify
                                key={wrk_flt_desc}
                                width={28}
                                sx={{ mr: 1 }}
                              />
                              Loading.......
                            </li>
                          );
                        }

                        return (
                          <li
                            {...props}
                            key={wrk_flt_desc}
                            value={wrk_flt_desc}
                          >
                            <Iconify
                              key={wrk_flt_fault_cd}
                              width={28}
                              sx={{ mr: 1 }}
                            />
                            {wrk_flt_fault_cd} : {wrk_flt_desc}
                          </li>
                        );
                      }}
                    />
                  </div>
                  {loadingLabel.faultCode ? (
                    <div
                    // style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
                    >
                      <img
                        src={Spin}
                        alt="loderImg"
                        style={{ width: "30px" }}
                      />
                    </div>
                  ) : null}
                  {/* Asset Location description */}

                  <RHFTextField
                    name="wkr_mst_wr_descs"
                    label="Request Description"
                    multiline
                    rows={4}
                  />

                  <div className="usrFrmFldTwo">
                    {errorMessage && (
                      <div className="erMsg">{errorMessage}</div>
                    )}

                    <RHFUpload
                      multiple
                      thumbnail
                      name="images"
                      accept="image/*"
                      maxSize={3145728}
                      onDrop={handleDrop}
                      onRemove={handleRemoveFile}
                      onRemoveAll={handleRemoveAllFiles}
                      onUpload={() => console.info("ON UPLOAD")}
                    />
                  </div>
                </Box>
              </Card>

              {/* new text field */}
              <Stack alignItems="inherit" sx={{ mt: 2 }}>
                {isLoading ? (
                  <LoadingButton
                    type="submit"
                    variant="contained"
                    loading={isSubmitting}
                    sx={{
                      "& .MuiCircularProgress-root": {
                        width: "100px",
                        height: "100px",
                      },
                    }}
                  >
                    {" "}
                    <img
                      src={LoderImg}
                      alt="loderImg"
                      style={{ width: "50px" }}
                    />
                  </LoadingButton>
                ) : (
                  <LoadingButton
                    type="submit"
                    variant="contained"
                    loading={isSubmitting}
                    disabled={disable}
                    sx={{
                      "& .MuiCircularProgress-root": {
                        width: "100px",
                        height: "100px",
                      },
                    }}
                  >
                    Save
                  </LoadingButton>
                )}
              </Stack>
            </Grid>
          </Grid>
        </form>
      </FormProvider>
    </>
  );
}

UserNewEditForm.propTypes = {
  currentUser: PropTypes.object,
};
